
import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle, AlertCircle, Loader2, ArrowRight } from 'lucide-react';

interface LoadingViewProps {
  debugInfo?: string;
}

export const LoadingView = ({ debugInfo }: LoadingViewProps) => {
  return (
    <div className="flex flex-col items-center py-8">
      <Loader2 className="h-12 w-12 text-primary animate-spin mb-4" />
      <h2 className="text-xl font-medium mb-2">Authentification en cours</h2>
      <p className="text-gray-600 text-center mb-6">
        Nous sommes en train de traiter votre authentification YouTube. Veuillez patienter...
      </p>
      
      {debugInfo && (
        <div className="mt-6 w-full">
          <details className="text-xs">
            <summary className="cursor-pointer text-gray-500 hover:text-gray-700">
              Informations de débogage
            </summary>
            <pre className="mt-2 p-2 bg-gray-100 rounded overflow-auto max-h-40 text-gray-700">
              {debugInfo}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
};

export const SuccessView = () => {
  return (
    <div className="flex flex-col items-center py-8">
      <div className="bg-green-100 p-4 rounded-full mb-6">
        <CheckCircle className="h-12 w-12 text-green-600" />
      </div>
      <h2 className="text-xl font-medium mb-2">Chaîne YouTube connectée avec succès!</h2>
      <p className="text-gray-600 text-center mb-6">
        Votre chaîne YouTube a été connectée avec succès à votre profil. Vous serez redirigé vers votre tableau de bord dans quelques instants.
      </p>
      <div className="flex items-center justify-center text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
        <span>Redirection automatique...</span>
      </div>
    </div>
  );
};

interface ErrorViewProps {
  errorMessage: string;
  debugInfo?: string;
  handleRetry: () => void;
}

export const ErrorView = ({ errorMessage, debugInfo, handleRetry }: ErrorViewProps) => {
  return (
    <div className="flex flex-col items-center py-8">
      <div className="bg-red-100 p-4 rounded-full mb-6">
        <AlertCircle className="h-12 w-12 text-red-600" />
      </div>
      <h2 className="text-xl font-medium mb-2">Une erreur est survenue</h2>
      <p className="text-gray-600 text-center mb-6">
        {errorMessage}
      </p>
      <div className="flex flex-col space-y-3 w-full max-w-xs">
        <Button onClick={handleRetry} className="w-full">
          Réessayer
        </Button>
        <Button variant="outline" onClick={() => window.location.href = '/dashboard'} className="w-full">
          Retour au tableau de bord
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
      
      {debugInfo && (
        <div className="mt-6 w-full">
          <details className="text-xs">
            <summary className="cursor-pointer text-gray-500 hover:text-gray-700">
              Informations de débogage
            </summary>
            <pre className="mt-2 p-2 bg-gray-100 rounded overflow-auto max-h-40 text-gray-700">
              {debugInfo}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
};
